export interface Payment {
  id: string;
  token: string;
  biller_code?: string;
  method: PaymentMethod;
  amount: number;
  receipt: number;
  frequency?: number;
  scheduled_at: Date | string;
  status?: boolean | null;
  resolvable?: boolean | null;
  resolved?: boolean | null;
  plan_id?: string;
  processed_at?: Date;
  debt_amount?: number;
  type: string;
  debt?: {
    id: number;
    number: number;
    status: string;
  };
}

export enum PaymentMethod {
  CREDIT_CARD = 'card',
  DIRECT_DEBIT = 'direct',
  BPAY = 'bpay',
}

export interface BPayDetails {
  biller_code: number;
  crn: number;
}



// WEBPACK FOOTER //
// ./src/app/core/data/payments/payment.model.ts